import { Link } from 'react-router-dom';
import { useJobs, useGlobal } from '../state';
import { Button } from '../components/input';
import { LeftNav } from '../components/nav';
import { JobsList } from '../components/job';
import { Code } from '../components/code';

export default function Dashboard() {
  const { apiKey } = useGlobal();

  return (
    <LeftNav>
      <h2>API Key</h2>
      <div>
        Your API key is <Code language="text" code={apiKey} inline copy />
      </div>

      <h2>Recent Jobs</h2>
      <JobsList limit={10} />
    </LeftNav>
  );
}
